import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Stack,
  HStack,
  Select,
  Box,
  useToast,
} from '@chakra-ui/react';
import { Auth } from 'aws-amplify';

function AuthModal({ type, onClose, isOpen, changeAuthType, setAuth }) {
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const initialRef = React.useRef(null);

  const signuphandler = async e => {
    e.preventDefault();
    const name = e.target.name.value;
    const email = e.target.email.value;
    const business = e.target.business.value;
    const category = e.target.category.value;
    const password = e.target.password.value;

    setLoading(true);
    try {
      const res = await Auth.signUp({
        username: email,
        password: password,
        attributes: {
          email,
          name,
          'custom:category': category,
          'custom:business': business,
        },
      });
      console.log(res);
      toast({
        status: 'info',
        title: 'signup successful, check your mail for verification code',
        duration: '60000',
        isClosable: true,
      });

      //do smart contract call here!!!
      //do smart contract call here!!!
      //for the sign up

      setLoading(false);

      changeAuthType(0);
    } catch (error) {
      if (error.name === 'UsernameExistsException') {
        toast({
          status: 'info',
          title: 'Email already registered',
          description: error.message,
          duration: '3000',
          isClosable: true,
        });
        setLoading(false);

        return;
      }
      toast({
        status: 'error',
        title: 'signup unsuccessful, try again',
        description: error.message,
        duration: '3000',
        isClosable: true,
      });
      setLoading(false);
    }
  };
  const loginhandler = async e => {
    e.preventDefault();
    setLoading(true);
    const email = e.target.email.value;

    const password = e.target.password.value;

    try {
      const user = await Auth.signIn(email, password);
      toast({
        status: 'info',
        title: 'Signed in',
        duration: '3000',
        isClosable: true,
      });
      setLoading(false);
      localStorage.setItem('merchantdata', JSON.stringify(user.attributes)); //saving to local in case of refresh
      setAuth(user.attributes);
    } catch (error) {
      toast({
        status: 'error',
        title: 'signin unsuccessful, try again',
        description: error.message,
        duration: '3000',
        isClosable: true,
      });
      setLoading(false);
    }
  };

  const confirm = async e => {
    e.preventDefault();
    setLoading(true);

    const code = e.target.code.value;
    const email = e.target.email.value;
    try {
      await Auth.confirmSignUp(email, code);
      toast({
        status: 'info',
        title: 'confirmed, login now',
        duration: '6000',
        isClosable: true,
      });
      setLoading(false);
      changeAuthType(1);
    } catch (error) {
      toast({
        status: 'error',
        title: 'confirm unsuccessful, try again',
        description: error.message,
        duration: '3000',
        isClosable: true,
      });
      setLoading(false);
    }
  };

  return (
    <>
      <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {type === 'login'
              ? 'LOGIN to dashboard'
              : type === 'signup'
              ? 'SIGNUP as Merchant'
              : 'CONFIRM ACCOUNT'}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            {type === 'signup' ? (
              <Stack spacing="4" as="form" id="signup" onSubmit={signuphandler}>
                <FormControl mt={4} isRequired>
                  <FormLabel>Name</FormLabel>
                  <Input placeholder="Full name" name="name" />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Email</FormLabel>
                  <Input
                    ref={initialRef}
                    placeholder="Email addr."
                    name="email"
                  />
                </FormControl>
                <HStack spacing="5">
                  <FormControl w="75%" isRequired>
                    <FormLabel>Business name</FormLabel>
                    <Input
                      ref={initialRef}
                      placeholder="Business name"
                      name="business"
                    />
                  </FormControl>
                  <FormControl w="35%" isRequired>
                    <FormLabel> Category</FormLabel>
                    <Select isRequired name="category">
                      <option disabled defaultValue={'Category'}>
                        Category
                      </option>
                      <option value="Fashion">Fashion</option>
                      <option value="Electronics">Electronics</option>
                      <option value="Cosmetics">Cosmetics</option>
                      <option value="Food">Food</option>
                      <option value="Phones">Phones</option>
                    </Select>
                  </FormControl>
                </HStack>

                <FormControl mt={4} isRequired>
                  <FormLabel>Password</FormLabel>
                  <Input
                    type="password"
                    placeholder="********"
                    name="password"
                  />
                </FormControl>
              </Stack>
            ) : type === 'login' ? (
              <Box as="form" id="login" onSubmit={loginhandler}>
                <FormControl isRequired>
                  <FormLabel>Email</FormLabel>
                  <Input
                    ref={initialRef}
                    type="email"
                    placeholder="Email addr."
                    name="email"
                  />
                </FormControl>

                <FormControl mt={4} isRequired>
                  <FormLabel>Password</FormLabel>
                  <Input
                    type="password"
                    placeholder="********"
                    name="password"
                  />
                </FormControl>
              </Box>
            ) : (
              <Box as="form" id="confirm" onSubmit={confirm}>
                <FormControl isRequired>
                  <FormLabel>Email</FormLabel>
                  <Input
                    ref={initialRef}
                    type="email"
                    placeholder="Email addr."
                    name="email"
                  />
                </FormControl>

                <FormControl mt={4} isRequired>
                  <FormLabel>Code</FormLabel>
                  <Input type="text" placeholder="enter code" name="code" />
                </FormControl>
              </Box>
            )}
          </ModalBody>

          <ModalFooter>
            <Button
              isLoading={loading}
              type="submit"
              form={
                type === 'login'
                  ? 'login'
                  : type === 'signup'
                  ? 'signup'
                  : 'confirm'
              }
              colorScheme="blue"
              mr={3}
            >
              Save
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default AuthModal;
